// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"670":"f72a443be1bfc909b0fc","824":"2d8e5548cd58ce678e30","904":"90b81fabed286fc0059e"}[chunkId] + ".js";
};